// extracted by mini-css-extract-plugin
export default {"container":"Study_container__C1KW7","title":"Study_title__b3Ylj","items":"Study_items__6i-c4","studyItem":"Study_studyItem__4vcVa","icon":"Study_icon__ftCP+"};